const getGlobalState = (state, key) => (Array.isArray(state.admin[key]) ? state.admin[key].slice(0) : state.admin[key]);

export const getUsers = (state) => getGlobalState(state, 'users') || null;
export const getRoles = (state) => getGlobalState(state, 'roles') || [];
export const getPermissions = (state) => getGlobalState(state, 'permissions') || [];
export const getRoleCreateCallback = (state) => getGlobalState(state, 'roleCreateCallback');
export const getRoleDelCallback = (state) => getGlobalState(state, 'roleDelCallback');
export const getRoleDisableEnableCb = (state) => getGlobalState(state, 'roleDisableEnableCb');
export const getRolePermissions = (state) => getGlobalState(state, 'rolePermissions') || [];
export const getSelectedRoleId = (state) => getGlobalState(state, 'selectedRoleId');
